import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-navigation',
  templateUrl: './gas-icon-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconNavigationComponent { }
